import { createApi } from '@reduxjs/toolkit/query/react';

import {
  EmployeesEndpoints as Endpoints,
  type GetBranchEmployeesOrderRequest,
  type GetBranchEmployeesOrderResponse,
  type SetBranchEmployeesOrderRequest,
  type SetBranchEmployeesOrderResponse,
  type SetWorkStateRequest,
  type SetWorkStateResponse,
} from '@app/api/Employees/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { EMPLOYEES_RESOURCE } from '@app/constants';

export const employeesApi2 = createApi({
  reducerPath: 'employeesApi2',
  baseQuery: createApiBaseQuery(EMPLOYEES_RESOURCE),
  endpoints: ({ query, mutation }) => ({
    [Endpoints.GetBranchEmployeesOrder]: query<
      GetBranchEmployeesOrderResponse,
      GetBranchEmployeesOrderRequest
    >({
      query: (params) => ({
        url: Endpoints.GetBranchEmployeesOrder,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.SetBranchEmployeesOrder]: mutation<
      SetBranchEmployeesOrderResponse,
      SetBranchEmployeesOrderRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.SetBranchEmployeesOrder,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.SetWorkState]: mutation<
      SetWorkStateResponse,
      SetWorkStateRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.SetWorkState,
        method: Methods.POST,
        params,
        data,
      }),
    }),
  }),
});

export const {
  useGetBranchEmployeesOrderQuery,
  useLazyGetBranchEmployeesOrderQuery,
  useSetBranchEmployeesOrderMutation,
  useSetWorkStateMutation,
} = employeesApi2;
